import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/brand";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) nav(r.user?.role === "admin" ? "/admin" : "/");
    else setErr(r.error || "Login failed");
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="50 States Sober" className="w-16 h-16 rounded-full object-cover ring-1 ring-[var(--line)]" />
        </div>
        <h1 className="font-serif-display text-4xl text-center mb-2">Welcome back</h1>
        <p className="text-[var(--ink-soft)] text-center mb-10">Sign in to send messages and post in the guestbook.</p>

        <form onSubmit={submit} className="space-y-4">
          <input
            data-testid="login-email"
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full px-4 py-3 border border-[var(--line)] rounded-sm text-sm focus:outline-none focus:border-[var(--terracotta)] bg-[var(--bg)]"
          />
          <input
            data-testid="login-password"
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full px-4 py-3 border border-[var(--line)] rounded-sm text-sm focus:outline-none focus:border-[var(--terracotta)] bg-[var(--bg)]"
          />
          {err && <div data-testid="login-error" className="text-sm text-red-600">{err}</div>}
          <button data-testid="login-submit" disabled={loading}
            className="w-full bg-[var(--terracotta)] text-[var(--ink)] py-3 rounded-sm text-sm hover:bg-[var(--terracotta-dark)] disabled:opacity-50">
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-right">
            <Link to="/forgot-password" data-testid="login-forgot-password"
              className="text-xs text-[var(--ink-soft)] hover:text-[var(--forest)] hover:underline">
              Forgot password?
            </Link>
          </div>
        </form>

        <p className="text-sm text-center text-[var(--ink-soft)] mt-8">
          New here? <Link to="/register" data-testid="login-to-register" className="text-[var(--forest)] underline">Create an account</Link>
        </p>
      </div>
    </div>
  );
}
